import { useState, useEffect, useContext } from "react";
import { useSession } from "next-auth/react";
import { useFirebaseUser } from "utils/useFirebaseUser";
import { isTweetFromAccount } from "controllers/schedule";
import { firebaseClient } from "firebaseClient";
import { getAccount } from "utils/sessionHelper";

export const useDrafts = (loadBatch = 30) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [drafts, setDrafts] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);
  const isAuthenticated = useFirebaseUser();
  const { data: session } = useSession() ?? {}

  const loadDrafts = async () => {
    setIsLoading(true);
    await getDrafts();
    setIsLoading(false);
  }

  const getDrafts = async (type?: "loadMore") => {
    if (!isAuthenticated) {
      return;
    }

    let draftsCopy = type === "loadMore" ? [...drafts] : [];
    const db = firebaseClient.firestore();

    let query = db
      .collection("users")
      .doc(getAccount(session).id)
      .collection("tweets")
      .where("status", "==", "draft")
      .where("idAccount", "==", getAccount(session).idAccount)
      .orderBy("dateCreated", "desc");

    if (type === "loadMore" && draftsCopy.length > 0) {
      query = query.startAfter(draftsCopy[draftsCopy?.length - 1]?.dateCreated);
    }

    const docs = await query.limit(loadBatch).get();

    docs.forEach((doc) => {
      const data = doc.data();

      if (isTweetFromAccount(data, session)) {
        if (data.text === "") {
          db.collection("users")
            .doc(getAccount(session).id)
            .collection("tweets")
            .doc(doc.id)
            .delete();
        } else {
          draftsCopy.push(data);
        }
      }
    });

    setDrafts(draftsCopy);

    if (docs?.docs?.length === loadBatch) {
      setHasMore(true);
    } else {
      setHasMore(false);
    }
  };

  const onDelete = async (docId: string) => {
    const filteredDrafts = drafts.filter((d) => d.id !== docId);
    setDrafts(filteredDrafts);
  };

  const loadMoreDrafts = async () => {
    if (!isAuthenticated) {
      return;
    }

    setIsLoadingMore(true);
    await getDrafts("loadMore");
    setIsLoadingMore(false);
  }

  const onAddToQueue = async (docId: string) => {
    const filteredDrafts = drafts.filter((d) => d.id !== docId);
    setDrafts(filteredDrafts);
  }

  return {
    drafts,
    isLoading,
    hasMore,
    isLoadingMore,
    loadDrafts,
    onDelete,
    loadMoreDrafts,
    onAddToQueue
  }
}